module.exports = __webpack_public_path__ + "static/assets/22e1fb45c852ab96fc6eb36c510ab498.gif";